// extracted by mini-css-extract-plugin
export default {"background":"Login_background__5MhOV"};